
import { LockClosedIcon } from '@heroicons/react/solid';
import { useState, useEffect } from 'react';
import { HollowDotsSpinner } from 'react-epic-spinners';
import UserServices from './../services/UserServices';
import { ensureTenantId } from '../utils/tenantHelper';
export default function Token() {
    const [otp, setOtp] = useState("")
    const [formState, setFormState] = useState({ otpError: "", otpIsValidated: "", formIsSubmitting: false })
    const [loading, setLoading] = useState({ loading: false });

    const validate = {
        otpHandler: (event) => {
            setOtp(event.target.value);
            if (event.target.value.trim().length < 1) {
                setFormState({
                    ...formState,
                    otpError: "OTP cannot be empty",
                    otpIsValidated: false,
                });
                return
            }
            setFormState({
                ...formState,
                otpError: "",
                otpIsValidated: true
            })
        }
    }
    const authTKN = sessionStorage.getItem("authToken")
    const submit = async (e) => {
        e.preventDefault();
        setLoading({ loading: true });
        const isFilledCorrectly =
            formState.otpIsValidated
        setFormState({ ...formState, formIsSubmitting: true });
        if (isFilledCorrectly) {
            const data = {
                authToken: authTKN,
                otp: otp,
            }
            const validate = await UserServices.authToken(data);
            if (validate == null) {
                setLoading({ loading: true })
            } else {
                sessionStorage.setItem("token", validate.data.token)
                sessionStorage.setItem("user", JSON.stringify(validate.data.user));
                
                // Ensure tenantId is set before redirecting
                await ensureTenantId();
                window.location.href = "/dashboard"
            }
        }
        setLoading({ loading: false });
    }

    const check = async () => {
       var validate = sessionStorage.getItem("authToken");
       if(validate === null){
        window.location.href ="/"
       }
    }
    useEffect( () => {
        check();
    })
    return (
        <div>
            <div className="relative z-10">
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity">
                </div>
                <div className="fixed z-10 inset-0 overflow-y-auto">
                    <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">

                        <div className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-sm sm:w-full sm:p-6">
                            <div>
                                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-gray-100">
                                    <LockClosedIcon className="h-6 w-6 text-dark" aria-hidden="true" />
                                </div>
                                <div className="mt-3 text-center sm:mt-5">
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                                        Authenticate your account
                                    </h3>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500">
                                            Enter the 6-digit code from your token
                                        </p>
                                    </div>
                                    <form onSubmit={submit}>
                                        <div className='mt-5'>
                                            <input
                                                type="password"
                                                value={otp}
                                                required
                                                onChange={validate.otpHandler}
                                                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                placeholder="Enter token" />
                                            {!formState.otpIsValidated && formState.otpError && (
                                                <div className="text-red-800">
                                                    {formState.otpError}
                                                </div>
                                            )}
                                        </div>
                                    </form>
                                    {loading.loading === false ?
                                        <div className='justify-center flex mt-5' >
                                            <button
                                                type="submit"
                                                onClick={submit}
                                                className="w-1/2 flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white btn-primary"
                                            >
                                                Submit
                                            </button>
                                        </div> :
                                        <>
                                            <div className='flex justify-center mt-5'>
                                                <HollowDotsSpinner className="justify-center" size={20} color="#4D627E" />
                                            </div>
                                        </>}

                                </div>
                            </div>
                          
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}